// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/course_section_details.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_planners_v1_resources_course_section } from "./course_section_pb.js";
import { file_studyo_today_planners_v1_resources_course_section_role } from "./course_section_role_pb.js";
import { file_studyo_today_schools_v1_resources_course_section } from "@buf/studyo_studyo-today-schools.bufbuild_es/studyo/today/schools/v1/resources/course_section_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/course_section_details.proto.
 */
export const file_studyo_today_planners_v1_resources_course_section_details = /*@__PURE__*/
  fileDesc("Cj9zdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL2NvdXJzZV9zZWN0aW9uX2RldGFpbHMucHJvdG8SInN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMi+AEKFENvdXJzZVNlY3Rpb25EZXRhaWxzEkkKDmNvdXJzZV9zZWN0aW9uGAEgASgLMjEuc3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcy5Db3Vyc2VTZWN0aW9uEkMKBHJvbGUYAiABKA4yNS5zdHVkeW8udG9kYXkucGxhbm5lcnMudjEucmVzb3VyY2VzLkNvdXJzZVNlY3Rpb25Sb2xlElAKFnNjaG9vbHNfY291cnNlX3NlY3Rpb24YAyABKAsyMC5zdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMuQ291cnNlU2VjdGlvbkIqqgInU3R1ZHlvLlRvZGF5LlBsYW5uZXJzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_studyo_today_planners_v1_resources_course_section, file_studyo_today_planners_v1_resources_course_section_role, file_studyo_today_schools_v1_resources_course_section]);

/**
 * Describes the message studyo.today.planners.v1.resources.CourseSectionDetails.
 * Use `create(CourseSectionDetailsSchema)` to create a new message.
 */
export const CourseSectionDetailsSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_course_section_details, 0);

